// extracted by mini-css-extract-plugin
export default {"timer":"zegoTimer_timer__oP0-p"};